import React, { FC } from 'react';
import styled from 'styled-components';
import { Field, Chip } from './CompanyFieldAndHelpers';
import { Grid, Column, Item } from './CompanyGrid';
import { WWWCompanyDocument } from '../../../common/documents/WWWCompanyDocument';
import { Color } from '../Theme';

const Divider = styled.div`
  display: inline-block;
  margin: 0px 8px;
  vertical-align: -10%;
  height: 16px;
  width: 2px;
  background-color: ${Color.white};
`;

interface Props {
  company: WWWCompanyDocument;
  editable: boolean;
  premium: boolean;
  loading: boolean;
}

export const CompanyCertificateInfo: FC<Props> = ({ company, editable, premium, loading }) => {
  const { taitoCompetences } = company;

  return (
    <Grid>
      <Column>
        <Item>
          <Field label="Taitorekisteri" loading={loading} premium={premium} premiumOnly chip empty={!taitoCompetences.length}>
            {taitoCompetences.map((p, i) => (
              <Chip key={i}>
                {p.name} <Divider /> <b style={{ margin: '0 4px 0 0' }}>{p.totalAmountRange}</b> hlö
              </Chip>
            ))}
          </Field>
        </Item>
      </Column>
    </Grid>
  );
};
